import script from "./BaseTile.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTile.vue?vue&type=script&setup=true&lang=js"

import "./BaseTile.vue?vue&type=style&index=0&id=2491960d&scoped=true&lang=css"
script.__scopeId = "data-v-2491960d"

export default script